import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: 20,
        fontSize: '50px',
        fontWeight: 900,
        marginTop: '75px',
        [theme.breakpoints.up('sm')]: {
            marginTop: '105px',
        },
    }
}))

const Catalog = () => {
    const classes = useStyles()
    return (
        <>
            <Header />
            <div className={classes.container}>
                Coming Soon...
            </div>
            <Footer />
        </>
    )
}

export default Catalog;